export default __webpack_public_path__ + "static/media/klimfort_blanco_transparente.42cba0a6.png";